/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import { TextField } from '@material-ui/core';
import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { formatQuater } from '../../../../Display/Claim/store/action';
import {
  setPriceLoadDetailsChanged,
  updatePriceLoadDetailsTableCell,
} from '../../store/action';
import { checkQuaterIsValid } from '../RequestDrugPriceLoadManufactureTable';
import { checkActionAccessByRole } from '../../../../../SharedModules/utilities/utilities';
import { Tab } from 'react-bootstrap';
import {debounce} from  'lodash'

const RequestDrugPriceLoadDetailsTextFieldComponent = React.memo((props) => {
  const { colId } = props.column;
  const [isEnablebyRole, setIsEnablebyRole] = useState(
    checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
  );
  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);
  React.useEffect(() => {
    if (kcRoles?.userPrivileges.length > 0) {
      setIsEnablebyRole(
        checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
      );
    }
  }, []);

  const priceLoadDetailsTableData = useSelector(
    (state) => state.sharedState.requestDrugPriceLoad.priceLoadDetailsTableData
  );
  const dispatch = useDispatch();
  const [error, setError] = useState(false);
  const customId = ['price', 'bestPrice', 'calcUra'];
  const checkedHandler = (e) => {
    let { value } = e.target;
    if (props.type === 'number') {
      const inputValue = e.target.value;
      if (
        customId.includes(colId)
          ? inputValue.match(/^\d{0,15}(\.\d{0,6})?$/)
          : inputValue.match(/^[0-9]+$/)
      ) {
        value = inputValue;
      } else if (inputValue === '') {
        value = null;
      }
      optimiseValidationCall(props);
      dispatch(setPriceLoadDetailsChanged(true));
    } else {
      const inputValue = e.target.value;
      if (
        (colId === 'targetQtr' || colId === 'calcQtr') &&
        inputValue?.toUpperCase().match(/^[0-9/Q]+$/g)
      ) {
        value = inputValue.toUpperCase();
        optimiseValidationCall(props);
      } else if (
        (colId === 'targetQtr' || colId === 'calcQtr') &&
        inputValue === ''
      ) {
        value = null;
        optimiseValidationCall(props);
      } else {
        value = inputValue === '' ? null : inputValue;
        optimiseValidationCall(props);
      }
    }

    props.node.setDataValue(colId, value);
    dispatch(updatePriceLoadDetailsTableCell(props.rowIndex, colId, value));
  };

  const handleBlur = () => {
    const { colId } = props.column;
    let value = null;
    if (customId.includes(colId)) {
      value = props.value
        ? props.value === '.'
          ? '0.000000'
          : parseFloat(props.value)?.toFixed(6)
        : '0.000000';
    } else if (colId === 'targetQtr') {
      if (props.value && checkQuaterIsValid(props.value)) {
        value = formatQuater(props.value);
      } else {
        value = props.value;
      }
    } else {
      value = props.value;
    }

    props.node.setDataValue(colId, value);
    optimiseValidationCall(props);
    dispatch(setPriceLoadDetailsChanged(true));

    const localError = false;
  };

  // const debounce = (func) => {
  //   let timer;
  //   return function (...args) {
  //     const context = this;
  //     if (timer) clearTimeout(timer);
  //     timer = setTimeout(() => {
  //       timer = null;
  //       func.apply(context, args);
  //     }, 300);
  //   };
  // };

  const optimiseValidationCall = useCallback(
    debounce(props.onCustomChange,300),
    []
  );
  const handleChange = (e) => {
    props.node.setDataValue(colId, e.target.value);
    dispatch(setPriceLoadDetailsChanged(true));
  };

  const [isTabPressed, setIsTabPressed] = React.useState(false);

  React.useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Tab') {
        setIsTabPressed(true);
      } else {
        setIsTabPressed(false);
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  if (colId === 'price') {
    return (
      <div
        className={`fullWidth w-100 text-${
          props.textAlign || 'left'
        } td-active-cell ${error ? 'tBill-validate' : ''}`}
      >
        {/* <label
          className='m-0 hide-elm'
          htmlFor={`textfield_${props.column.colId}_${props.rowIndex}`}
        >
          <span>label</span>{' '}
        </label> */}
        <TextField
          className={'frr-display-hidden-label'}
          id={`textfield_${props.column.colId}_${props.rowIndex}`}
          label={'Price'}
          fullWidth
          placeholder=''
          InputLabelProps={{
            shrink: true,
          }}
          inputProps={{ maxLength: 22 }}
          InputProps={{ disableUnderline: true }}
          disabled={props.disabled || !isEnablebyRole || false}
          value={props.value || ''}
          onChange={(e) => {
            if (e.target.value && e.target.value.includes('.')) {
              const rx = /^[0-9]{0,15}(\.[0-9]{0,6})?$/;
              if (rx.test(e.target.value)) {
                handleChange(e);
              }
            } else {
              const rx_without = /^[0-9]{0,15}?$/;
              if (rx_without.test(e.target.value)) {
                handleChange(e);
              }
            }
          }}
          onBlur={(e) => {
            const value = e.target.value
              ? parseFloat(e.target.value)?.toFixed(6)
              : '0.000000';
            props.node.setDataValue('price', value);
          }}
          error={error}
          helperText=''
          tabIndex={0}
        />
      </div>
    );
  }
  return (
    <div
      className={`fullWidth w-100 text-${
        props.textAlign || 'left'
      } td-active-cell ${error ? 'tBill-validate' : ''}`}
    >
      {/* <label
        className='m-0 hide-elm'
        htmlFor={`textfield_${props.column.colId}_${props.rowIndex}`}
      >
        <span>label</span>{' '}
      </label> */}
      <TextField
        id={`textfield_${props.column.colId}_${props.rowIndex}`}
        className={'frr-display-hidden-label'}
        label={'fields'}
        fullWidth
        placeholder=''
        InputLabelProps={{
          shrink: true,
        }}
        inputProps={{
          maxlength: props.maxLength || 255,
          id: `textfield_${props.column.colId}_${props.rowIndex}`,
        }}
        InputProps={{ disableUnderline: true }}
        disabled={props.disabled || !isEnablebyRole || false}
        value={props.value || ''}
        onChange={checkedHandler}
        error={error}
        helperText=''
        onKeyDown={(e) => {
          if ((e.keyCode == 9 || e.keyCode == 39) && colId === 'calcUra')
            props.addRow(priceLoadDetailsTableData?.uraTableData);
        }}
        onBlur={(e) => handleBlur()}
      />
    </div>
  );
});

export default RequestDrugPriceLoadDetailsTextFieldComponent;
